import { isWorkspaceAdmin } from "@/components/helpers/workspace/permissions";
import { Button } from "@/components/ui/button";

interface WorkspaceAdminControllerProps {
  onAddUser: () => void;
  hasSelectedUsers?: boolean;
  onSetGroup: () => void;
  onRemove: () => void;
  onBulkSetCredits: () => void;
}

export function WorkspaceAdminController({
  onAddUser,
  hasSelectedUsers = false,
  onSetGroup,
  onRemove,
  onBulkSetCredits,
}: WorkspaceAdminControllerProps) {
  return (
    <div className={`flex flex-1 ${hasSelectedUsers ? "mt-2 lg:mt-0" : ""}`}>
      {!hasSelectedUsers ? (
        <div>
          {isWorkspaceAdmin() && (
            <Button
              onClick={() => {
                onAddUser();
              }}
              intent="primary"
            >
              + Add Users
            </Button>
          )}
        </div>
      ) : (
        <>
          <div className="mr-2">
            <Button
              disabled={!hasSelectedUsers}
              onClick={() => {
                onSetGroup();
              }}
              variant="outline"
              className="relative"
            >
              Set Group
            </Button>
          </div>
          {isWorkspaceAdmin() && (
            <>
              <div className="mr-2">
                <Button
                  disabled={!hasSelectedUsers}
                  onClick={() => {
                    onBulkSetCredits();
                  }}
                  variant="outline"
                  className="relative"
                >
                  Modify Credits
                </Button>
              </div>
              <div className="mr-2">
                <Button
                  disabled={!hasSelectedUsers}
                  onClick={() => {
                    onRemove();
                  }}
                  variant="outline"
                  className={`relative ${
                    hasSelectedUsers ? "text-red-600 hover:text-red-700" : ""
                  }`}
                >
                  Remove
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
